module.exports = __webpack_public_path__ + "static/media/people6.5d883de7.jpeg";